import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Navigation } from 'styled-icons/boxicons-solid';
import { Title } from '../../../index';

import * as S from './styled';

export default function Map() {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          contacts {
            map {
              title
            }
          }
        }
      }
      staticMap {
        center
        childFile {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `);

  function onWazeClickHandler() {
    const baseLink = 'https://www.waze.com/ul?navigate=yes&zoom=17';
    const routeLink = `${baseLink}&q=${data.staticMap.center}`;
    window.open(routeLink, '_blank');
  }

  function onMapsClickHandler() {
    const baseLink = 'https://maps.google.com?saddr=Current+Location';
    const routeLink = `${baseLink}&daddr=${data.staticMap.center}`;
    window.open(routeLink, '_blank');
  }

  return (
    <S.Card>
        <S.Map
        title="google-map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d535.538641163058!2d-49.28793457669775!3d-25.4496218772627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94dce30e1b8a296f%3A0x99f217b0c38935c9!2sConsult%C3%B3rio%20Odontol%C3%B3gico%20Dra.%20Juliana%20Macari!5e0!3m2!1sen!2sbr!4v1658598804150!5m2!1sen!2sbr"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      />
      <S.Container>
        <Title>{data.site.siteMetadata.contacts.map.title}</Title>
        <S.Actions>
          <S.Action onClick={onWazeClickHandler}>
            <Navigation size={20} />
            Waze
          </S.Action>
          <S.Action onClick={onMapsClickHandler}>
            <Navigation size={20} />
            Google Maps
          </S.Action>
        </S.Actions>
      </S.Container>
    </S.Card>
  );
}